<template>
    <div>
		<div class="mb-2">
			Добавить фильтр
		</div>
		
		<div class="my-button-group">
			<b-button
				v-for="filter in filters"
				:key="filter"
				variant="outline-secondary"
				@click="setFilter(filter)"
				:disabled="filterIsDisabled"
				size="sm"
			>
				{{ filter }}
			</b-button>
		</div>

		<div class="mb-2">
			Значение фильтра
			{{ filterValue }}
		</div>
		<b-form-input
			v-model="filterValue"
			type="range"
			:min="filterRange.min"
			:max="filterRange.max"
			step="0.005"
			@input="updateFilter"
			:disabled="isAvailableFilter"
		></b-form-input>
		
		<div class="text-right">
			<b-button
				pill
				variant="outline-primary"
				@click="setFilter('disable')"
				:disabled="filterIsDisabled"
				size="sm"
			>
				Сбросить
			</b-button>
		</div>
    </div>
</template>

<script>

import { fabric } from "fabric";

export default {
    props:[
        'canvas',
        'isVIP',
        'isSelected',
		'selectedType'
    ],
    data(){
        return {
            filterRange: {
				max: "",
				min: "",
			},
			filters: [
				"Grayscale",
				"Invert",
				"Sepia",
				"Brownie",
				"Brightness",
				"Contrast",
				"Saturation",
				"HueRotation",
				"Pixelate",
				"Noise",
				"Vintage",
				"Kodachrome",
				"Technicolor",
				"Polaroid",
			],
			currentFilter: "",
			filterValue: 0,

        }
    },
    computed:{
		filterIsDisabled(){
			return this.selectedType === 'image' ? false : true
		},
        isAvailableFilter() {
			const filters = [
				"brightness",
				"contrast",
				"saturation",
				"rotation", // hue
				"blocksize",
				"noise",
			];
			let cond = filters.filter((f) => f === this.currentFilter).length;
			return !cond ? true : false;
		},
    },
    methods:{
        updateFilter() {
			const obj = this.canvas.getActiveObject();
			let filter = obj.filters[0];
			let [param, value] = Object.entries(filter)[0];

			// console.log("param = ", param);
			console.log("value = ", value);
			// console.log("this.filterValue= ", this.filterValue);

			filter[param] = Number(this.filterValue);
			// console.log(filter[param]);

			obj.applyFilters();
			this.canvas.renderAll();
		},
		setFilter(filterName) {
			const obj = this.canvas.getActiveObject();
			console.log("setFilter(filterName) = ", filterName);

			const setFilter = (filterName, opt) => {
				obj.filters[0] = new fabric.Image.filters[filterName](opt);
				this.currentFilter = Object.keys(obj.filters[0])[0];
				this.filterValue = 0;
				console.log("this.currentFilter = ", this.currentFilter);
			};
			const setMinMaxRange = (min, max) => {
				this.filterRange.min = min;
				this.filterRange.max = max;
				console.log(
					`this.filterRange.min = ${min}`,
					`this.filterRange.max = ${max}`,
				);
			};

			switch (filterName.toLowerCase()) {
				case "grayscale": {
					setFilter(filterName);
					break;
				}
				case "invert": {
					setFilter(filterName);
					break;
				}
				case "sepia": {
					setFilter(filterName);
					break;
				}
				case "brownie": {
					setFilter(filterName);
					break;
				}
				case "brightness": {
					setMinMaxRange(-1, 1);
					setFilter(filterName, {
						brightness: this.filterValue,
					});
					break;
				}
				case "contrast": {
					setMinMaxRange(-1, 1);
					setFilter(filterName, {
						contrast: this.filterValue,
					});
					break;
				}
				case "saturation": {
					setMinMaxRange(-1, 1);
					setFilter(filterName, {
						saturation: this.filterValue,
					});
					break;
				}
				case "huerotation": {
					setMinMaxRange(-2, 2);
					setFilter(filterName, {
						rotation: this.filterValue,
					});

					break;
				}
				case "pixelate": {
					setMinMaxRange(2, 20);
					setFilter(filterName, {
						blocksize: this.filterValue,
					});
					break;
				}
				case "noise": {
					setMinMaxRange(0, 1000);
					setFilter(filterName, {
						noise: this.filterValue,
					});
					break;
				}
				case "disable": {
					this.filterValue = 0
					delete obj.filters[0];
					break;
				}
				case "vintage": {
					setFilter(filterName);
					break;
				}
				case "kodachrome": {
					setFilter(filterName);
					break;
				}
				case "technicolor": {
					setFilter(filterName);
					break;
				}
				case "polaroid": {
					setFilter(filterName);
					break;
				}
				default:
					console.log("defautl");
					break;
			}

			obj.applyFilters();
		},
    }
}
</script>

<style>

</style>